import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function MakeupShopDashboard() {
  const navigate = useNavigate();
  useEffect(() => { navigate('/makeup-shop/customers', { replace: true }); }, [navigate]);
  return null;
}
